import themes from '../themes';
import Config from '../config';
import baemingoBackground from '../Assets/images/baemingo/bg.png';
import baemingoLogo from '../Assets/images/baemingo/logo.svg';
import baemingoVideoBackground from '../Assets/video/baemingo/bg.mp4';
import ohpokeBackground from '../Assets/images/ohpoke/bg.png';
import ohpokeLogo from '../Assets/images/ohpoke/logo.svg';
import ohpokeSmallLogo from '../Assets/images/ohpoke/smallLogo.svg';
import ohpokeItemPlaceholder from '../Assets/images/ohpoke/itemPlaceholder.png';
import eggsBackground from '../Assets/images/eggs/bg.png';
import eggsLogo from '../Assets/images/eggs/logo.svg';
import eggsSmallLogo from '../Assets/images/eggs/smallLogo.svg';
import senstreetBackground from '../Assets/images/senstreet/bg.jpg';
import senstreetSmallLogo from '../Assets/images/senstreet/logo.png';
import senstreetItemPlaceholder from '../Assets/images/senstreet/itemPlaceholder.png';
import tacostudiosBackground from '../Assets/images/tacostudios/bg.png';
import tacostudiosLogo from '../Assets/images/tacostudios/logo.svg';
import tacostudiosSmallLogo from '../Assets/images/tacostudios/smallLogo.svg';
import nycBackground from '../Assets/images/nyc/bg.jpg';
import nycLogo from '../Assets/images/nyc/logo.svg';
import brodernasBackground from '../Assets/images/brodernas/bg.jpg';
import brodernasLogo from '../Assets/images/brodernas/logo.svg';
import andysburgerBackground from '../Assets/images/andysburger/bg.png';
import andysburgerVideo from '../Assets/video/andysburger/bg.mp4';
import andysburgerLogo from '../Assets/images/andysburger/logo.svg';
import saigonBaguetteBackground from '../Assets/images/saigonBaguette/bg.jpg';
import saigonBaguetteLogo from '../Assets/images/saigonBaguette/logo.svg';
import reloadSuperfoodbarBackground from '../Assets/images/reload-superfoodbar/bg.jpg';
import reloadSuperfoodbarLogo from '../Assets/images/reload-superfoodbar/logo.svg';
import ubSushiBackground from '../Assets/images/ub-sushi/bg.jpg';
import ubSushiLogo from '../Assets/images/ub-sushi/logo.svg';
import umamiBackground from '../Assets/images/umami/bg.png';
import umamiLogo from '../Assets/images/umami/logo.png';
import ilovePizzaBackground from '../Assets/images/ilovePizza/bg.jpg';
import ilovePizzaLogo from '../Assets/images/ilovePizza/logo.svg';
import fiffisBackground from '../Assets/images/fiffis/bg.jpg';
import fiffisLogo from '../Assets/images/fiffis/logo.png';
import zocaloBackground from '../Assets/images/zocalo/bg.jpeg';
import zocaloLogo from '../Assets/images/zocalo/logo.png';
import zocaloDKVideoBackground from '../Assets/video/zocaloDK/bg.mp4';
import nemNemQuanBackground from '../Assets/images/nemNemQuan/bg.png';
import nemNemQuanLogo from '../Assets/images/nemNemQuan/logo.png';
import greekGrillHouseBackground from '../Assets/images/greekGrillHouse/bg.jpg';
import greekGrillHouseLogo from '../Assets/images/greekGrillHouse/logo.png';
import barcontrolBackground from '../Assets/images/barcontrol/bg.png';
import barcontrolLogo from '../Assets/images/barcontrol/logo.svg';
import vanadisBackground from '../Assets/images/vanadis/bg.png';
import vanadisLogo from '../Assets/images/vanadis/logo.png';
import wrapsodyLogo from '../Assets/images/wrapsody/logo.svg';
import wrapsodyBackground from '../Assets/images/wrapsody/bg.png';
import hakeeBackground from '../Assets/images/hakee/bg.png';
import hakeeLogo from '../Assets/images/hakee/logo.png';
import thaitecBackground from '../Assets/images/thaitec/bg.jpg';
import thaitecLogo from '../Assets/images/thaitec/logo.png';
import navarazaBackground from '../Assets/images/navaraza/bg.png';
import navarazaLogo from '../Assets/images/navaraza/logo.png';
import ryfylkeGardsysteriBackground from '../Assets/images/ryfylkeGardsysteri/bg.jpeg';
import ryfylkeGardsysteriLogo from '../Assets/images/ryfylkeGardsysteri/logo.png';
import svithunHotelLogo from '../Assets/images/svithunHotel/logo.png';
import pasterianLogo from '../Assets/images/pasterian/logo.png';
import pasterianBackground from '../Assets/images/pasterian/bg.png';
import jettzBurgerLogo from '../Assets/images/jettzBurger/logo.png';
import jettzBurgerBackground from '../Assets/images/jettzBurger/bg.png';
import varPizzaLogo from '../Assets/images/varPizza/logo.png';
import varPizzaBackground from '../Assets/images/varPizza/bg.png';
import trappanLogo from '../Assets/images/trappan/logo.svg';
import trappanBackground from '../Assets/images/trappan/bg.png';
import kebabdudesLogo from '../Assets/images/kebabdudes/logo.png';
import kebabdudesBackground from '../Assets/images/kebabdudes/bg.jpg';
import kebabdudesSmallLogo from '../Assets/images/kebabdudes/smallLogo.png';
import sakuraLogo from '../Assets/images/sakura/logo.png';
import sakuraBackground from '../Assets/images/sakura/bg.png';
import nollettanLogo from '../Assets/images/nollettan/logo.png';
import nollettanBackground from '../Assets/images/nollettan/bg.png';
import baoYingLogo from '../Assets/images/baoYing/logo.png';
import baoYingBackground from '../Assets/images/baoYing/bg.jpg';

type Logo = {
  url: string;
  width: number;
  height: number;
  offsetTop?: number;
};

const getSuffix = (companyId: string) => {
  return (
    Config.Development.COMPANY_ID_SUFFIX[companyId] ||
    Config.Production.COMPANY_ID_SUFFIX[companyId]
  );
};

const getTheme = (companyId: string) => {
  const suffix = getSuffix(companyId);
  if (!suffix) {
    return {};
  }
  return themes[suffix];
};

const groupWelcomeImages = (bg: string, logo: Logo) => {
  return {
    background: bg,
    logo: {
      url: logo.url,
      width: logo.width,
      height: logo.height,
      offsetTop: logo.offsetTop,
    },
  };
};

export const getWelcomeImages = (companyId: string) => {
  const suffix = getSuffix(companyId);

  switch (suffix) {
    case 'baemingo':
      return groupWelcomeImages(baemingoBackground, {
        url: '',
        width: 0,
        height: 0,
      });
    case 'ohpoke':
      return groupWelcomeImages(ohpokeBackground, { url: ohpokeLogo, width: 533, height: 393 });
    case 'eggs':
      return groupWelcomeImages(eggsBackground, { url: eggsLogo, width: 504, height: 504 });
    case 'senstreet':
      return groupWelcomeImages(senstreetBackground, {
        url: '',
        width: 0,
        height: 0,
      });
    case 'tacostudios':
      return groupWelcomeImages(tacostudiosBackground, {
        url: tacostudiosLogo,
        width: 504,
        height: 504,
      });
    case 'nyc':
      return groupWelcomeImages(nycBackground, {
        url: '',
        width: 0,
        height: 0,
      });

    case 'brodernas':
      return groupWelcomeImages(brodernasBackground, {
        url: brodernasLogo,
        width: 650,
        height: 650,
      });

    case 'andysburger':
      return groupWelcomeImages(andysburgerBackground, {
        url: '',
        width: 0,
        height: 0,
      });

    case 'saigonBaguette':
      return groupWelcomeImages(saigonBaguetteBackground, {
        url: '',
        width: 0,
        height: 0,
      });

    case 'reloadSuperfoodbar':
      return groupWelcomeImages(reloadSuperfoodbarBackground, {
        url: '',
        width: 0,
        height: 0,
      });

    case 'ubSushi':
      return groupWelcomeImages(ubSushiBackground, {
        url: '',
        width: 0,
        height: 0,
      });
    case 'umami':
      return groupWelcomeImages(umamiBackground, {
        url: '',
        width: 0,
        height: 0,
      });
    case 'ilovePizza':
      return groupWelcomeImages(ilovePizzaBackground, {
        url: '',
        width: 0,
        height: 0,
      });
    case 'fiffis':
      return groupWelcomeImages(fiffisBackground, {
        url: fiffisLogo,
        width: 365,
        height: 182,
        offsetTop: 600,
      });
    case 'zocalo':
      return groupWelcomeImages(zocaloBackground, {
        url: zocaloLogo,
        width: 650,
        height: 326,
      });
    case 'zocaloDK':
      return groupWelcomeImages(zocaloBackground, {
        url: zocaloLogo,
        width: 650,
        height: 326,
      });
    case 'nemNemQuan':
      return groupWelcomeImages(nemNemQuanBackground, {
        url: nemNemQuanLogo,
        width: 482,
        height: 477,
      });
    case 'greekGrillHouse':
      return groupWelcomeImages(greekGrillHouseBackground, {
        url: greekGrillHouseLogo,
        width: 650,
        height: 53,
        offsetTop: 250,
      });
    case 'barcontrol':
      return groupWelcomeImages(barcontrolBackground, {
        url: '',
        width: 0,
        height: 0,
      });
    case 'vanadis':
      return groupWelcomeImages(vanadisBackground, {
        url: '',
        width: 0,
        height: 0,
      });
    case 'wrapsody':
      return groupWelcomeImages(wrapsodyBackground, {
        url: wrapsodyLogo,
        width: 533,
        height: 207,
        offsetTop: 550,
      });
    case 'hakee':
      return groupWelcomeImages(hakeeBackground, {
        url: '',
        width: 0,
        height: 0,
      });
    case 'thaitec':
      return groupWelcomeImages(thaitecBackground, {
        url: thaitecLogo,
        width: 614,
        height: 300,
        offsetTop: 400,
      });
    case 'navaraza':
      return groupWelcomeImages(navarazaBackground, {
        url: '',
        width: 0,
        height: 0,
      });
    case 'ryfylkeGardsysteri':
      return groupWelcomeImages(ryfylkeGardsysteriBackground, {
        url: ryfylkeGardsysteriLogo,
        width: 504,
        height: 504,
      });
    case 'svithunHotel':
      return groupWelcomeImages('', {
        url: svithunHotelLogo,
        width: 650,
        height: 371,
        offsetTop: 250,
      });
    case 'pasterian':
      return groupWelcomeImages(pasterianBackground, {
        url: '',
        width: 0,
        height: 0,
      });
    case 'jettzBurger':
      return groupWelcomeImages(jettzBurgerBackground, {
        url: '',
        width: 0,
        height: 0,
      });
    case 'varPizza':
      return groupWelcomeImages(varPizzaBackground, {
        url: varPizzaLogo,
        width: 450,
        height: 274,
        offsetTop: 235,
      });
    case 'trappan':
      return groupWelcomeImages(trappanBackground, {
        url: '',
        width: 0,
        height: 0,
      });
    case 'kebabdudes':
      return groupWelcomeImages(kebabdudesBackground, {
        url: kebabdudesLogo,
        width: 600,
        height: 600,
        offsetTop: 0,
      });
    case 'sakura':
      return groupWelcomeImages(sakuraBackground, {
        url: sakuraLogo,
        width: 530,
        height: 171,
        offsetTop: 128,
      });
    case 'nollettan':
      return groupWelcomeImages(nollettanBackground, {
        url: nollettanLogo,
        width: 600,
        height: 600,
      });
    case 'baoYing':
      return groupWelcomeImages(baoYingBackground, {
        url: baoYingLogo,
        width: 504,
        height: 505,
      });
    default:
      return groupWelcomeImages('', { url: '', width: 0, height: 0 });
  }
};

export const getWelcomeVideo = (companyId: string) => {
  const suffix = getSuffix(companyId);

  switch (suffix) {
    case 'baemingo':
      return baemingoVideoBackground;
    case 'zocaloDK':
      return zocaloDKVideoBackground;
    case 'andysburger':
      return andysburgerVideo;
    default:
      return undefined;
  }
};

export const getSmallLogo = (
  companyId: string,
): { url: string; width: number; height?: number; colored?: boolean } => {
  const suffix = getSuffix(companyId);

  switch (suffix) {
    case 'baemingo':
      return { url: baemingoLogo, width: 250, height: 19 };
    case 'ohpoke':
      return { url: ohpokeSmallLogo, width: 226, height: 64 };
    case 'eggs':
      return { url: eggsSmallLogo, width: 162, height: 64 };
    case 'senstreet':
      return { url: senstreetSmallLogo, width: 108, height: 130 };
    case 'tacostudios':
      return { url: tacostudiosSmallLogo, width: 240, height: 200 };
    case 'nyc':
      return { url: nycLogo, width: 200, colored: true };
    case 'brodernas':
      return { url: brodernasLogo, width: 200, height: 200 };
    case 'andysburger':
      return { url: andysburgerLogo, width: 110, height: 110 };
    case 'saigonBaguette':
      return { url: saigonBaguetteLogo, width: 135, height: 135 };
    case 'reloadSuperfoodbar':
      return { url: reloadSuperfoodbarLogo, width: 180, height: 105 };
    case 'ubSushi':
      return { url: ubSushiLogo, width: 138, height: 138 };
    case 'umami':
      return { url: umamiLogo, width: 283, height: 200, colored: true };
    case 'ilovePizza':
      return { url: ilovePizzaLogo, width: 300, height: 200, colored: true };
    case 'fiffis':
      return { url: fiffisLogo, width: 250, height: 124, colored: true };
    case 'zocalo':
      return { url: zocaloLogo, width: 300, height: 150, colored: true };
    case 'zocaloDK':
      return { url: zocaloLogo, width: 300, height: 150, colored: true };
    case 'nemNemQuan':
      return { url: nemNemQuanLogo, width: 150, height: 150, colored: true };
    case 'greekGrillHouse':
      return { url: greekGrillHouseLogo, width: 250, height: 20, colored: true };
    case 'barcontrol':
      return { url: barcontrolLogo, width: 250, height: 19 };
    case 'vanadis':
      return { url: vanadisLogo, width: 150, height: 150, colored: true };
    case 'wrapsody':
      return { url: wrapsodyLogo, width: 231, height: 90 };
    case 'hakee':
      return { url: hakeeLogo, width: 185, height: 64, colored: true };
    case 'thaitec':
      return { url: thaitecLogo, width: 245, height: 120, colored: true };
    case 'navaraza':
      return { url: navarazaLogo, width: 220, height: 78, colored: true };
    case 'ryfylkeGardsysteri':
      return { url: ryfylkeGardsysteriLogo, width: 130, height: 130, colored: true };
    case 'svithunHotel':
      return { url: svithunHotelLogo, width: 227, height: 130, colored: true };
    case 'pasterian':
      return { url: pasterianLogo, width: 242, height: 70, colored: true };
    case 'jettzBurger':
      return { url: jettzBurgerLogo, width: 140, height: 140, colored: true };
    case 'varPizza':
      return { url: varPizzaLogo, width: 147, height: 90, colored: true };
    case 'trappan':
      return { url: trappanLogo, width: 248, height: 140, colored: true };
    case 'kebabdudes':
      return { url: kebabdudesSmallLogo, width: 200, height: 200, colored: true };
    case 'sakura':
      return { url: sakuraLogo, width: 310, height: 100, colored: true };
    case 'nollettan':
      return { url: nollettanLogo, width: 200, height: 200, colored: true };
    case 'baoYing':
      return { url: baoYingLogo, width: 200, height: 200, colored: true };
    default:
      return { url: '', width: 0, height: 0 };
  }
};

export const getItemPlaceholderImage = (companyId: string) => {
  const suffix = getSuffix(companyId);

  switch (suffix) {
    case 'ohpoke':
      return ohpokeItemPlaceholder;
    case 'eggs':
      return '';
    case 'senstreet':
      return senstreetItemPlaceholder;
    default:
      return '';
  }
};

export default getTheme;
